import React,{useContext, useEffect} from 'react'
import noteContext from '../context/notes/noteContext'
const About = () => {

  return (
    <div>
      this is about 
    </div>
  )
}

export default About
